import { AppState } from '../../types';
import { StateLists } from './types';

export const selectLists = (state: AppState): StateLists => state.lists.lists;

export const selectHoveredItemId = (state: AppState): number => state.lists.ux.hoveredRow;
